import styled from "styled-components";

export const CropImageContainer = styled.div`
  .image-cropper-label {
    align-items: center;
    background-color: ${({ theme }) => theme.groups.dropdownModeration};
    border-radius: 0.25rem;
    border: none;
    color: ${({ theme }) => theme.groups.secondaryText};
    display: flex;
    flex-direction: row;
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: max(0.6vw, 0.875rem);
    gap: 0.5rem;
    justify-content: center;
    padding: 0.5rem 1rem;
    line-height: 150%;
    opacity: 0.8;
    transition: all 300ms ease-in-out;
    width: max-content;

    svg * {
      stroke: ${({ theme }) => theme.groups.secondaryText};
    }

    :hover {
      cursor: pointer;
      opacity: 1;
    }

    > input {
      display: none;
    }
  }

  #remove-image {
    align-items: center;
    background-color: #ff2d2d;
    border-radius: 0.25rem;
    border: none;
    color: #f2f2f2;
    display: flex;
    flex-direction: row;
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: max(0.6vw, 0.875rem);
    gap: 0.5rem;
    justify-content: center;
    padding: 0.5rem 1rem;
    line-height: 150%;
    opacity: 0.8;
    transition: all 300ms ease-in-out;
    width: max-content;

    svg * {
      stroke: #f2f2f2;
    }

    :hover {
      cursor: pointer;
      opacity: 1;
    }
  }
`;

export const CropImageModal = styled.div`
  backdrop-filter: blur(40px);
  display: grid;
  height: 100%;
  left: 0;
  position: fixed;
  place-items: center;
  transition: all 100ms ease-in-out;
  top: 4rem;
  overflow: auto;
  z-index: 9999999;
  width: 100%;
  max-width: 100% !important;
  background: ${({ theme }) => theme.groups.activitiesModalBackgroundColor};
  padding: 1.5rem;

  @media (max-width: 1099px) {
    padding-left: 0;
  }

  .image-cropper-container {
    height: 85%;
  }

  .image-cropper-container .image-cropper-button-container {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-bottom: 1.5rem;

    button {
      align-items: center;
      border-radius: 0.25rem;
      border: none;
      color: #f2f2f2;
      display: flex;
      flex-direction: row;
      font-family: "Inter";
      font-style: normal;
      font-weight: 600;
      font-size: max(0.6vw, 0.875rem);
      gap: 0.5rem;
      justify-content: center;
      padding: 0.5rem 1rem;
      line-height: 150%;
      opacity: 0.8;
      transition: opacity 100ms ease-in-out;
      width: max-content;

      svg * {
        stroke: #f2f2f2;
      }

      :hover {
        cursor: pointer;
        opacity: 1;
      }
    }

    #save {
      background-color: #00b94a;
    }

    #cancel {
      background-color: #af0000;
    }
  }
`;
